import Vue from 'vue'
import router from '@/router'
import menu from '@/assets/js/menu'
import request from '@/helpers/request'
import localStorageHelpers from '@/helpers/localStorage'
import * as Sentry from '@sentry/browser'

export default {
  LOGIN({ commit, state, dispatch }, data) {
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.login}`,
      {
        phone: data.phone,
        password: data.password,
      },
      false,
    )
      .then(response => {
        localStorageHelpers.__setToken(response.data.data.token)
        dispatch('GET_PERMISSIONS_FOR_USER')
          .then(() => {
            router.push({ path: Vue.config.modules.crm.route.index })
          })
          .catch(err => {
            console.info(err)
          })
      })
      .catch(err => {
        commit('updateIsError', true)
        return
      })
  },
  WHO_I_AM({ commit, state }) {
    if (!localStorage.hasOwnProperty('token')) {
      router.push({ path: Vue.config.modules.crm.route.auth })
    }
    request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.iam}`, {}, true).then(response => {
      if (response.data.result !== 'success' || response.data.data == null) {
        router.push({ path: Vue.config.modules.crm.route.auth })
      }

      const user = response.data.data

      commit('setUser', response.data.data)

      Sentry.configureScope(scope => {
        scope.setUser({
          id: _.get(user, 'id', null),
        })

        scope.setTag('unit', _.get(user, 'unit.name', null))
        scope.setTag('unit_id', _.get(user, 'unit.id', null))
      })

      commit('setUserAvatar', user.images[0].filename)
      commit('setMenu', menu)
    })
  },
  LOGOUT({ commit, state }) {
    if (localStorage.getItem('prevUserToken')) {
      const prevToken = localStorage.getItem('prevUserToken')
      localStorage.setItem('token', prevToken)
      localStorage.removeItem('prevUserToken')
      location.reload()
    } else {
      localStorage.removeItem('token')
      commit('setMenu', null)
      router.push({ path: Vue.config.modules.crm.route.auth })
    }
  },
  CLOSE_ALL_SESSIONS({ commit, state }, userID) {
    request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.invalidateSessions.replace('$1', userID)}`,
      {},
      true,
    ).then(response => {
      localStorage.removeItem('token')
      commit('setMenu', null)
      router.push({ path: Vue.config.modules.crm.route.auth })
    })
  },
  GET_EMPLOYER_PERMISSIONS({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.employers.permission.replace('$1', payload.employerId)}`,
        {
          params: {
            full: payload.full,
          },
        },
        false,
      ).then(response => {
        commit('setEmployerPermissions', response.data.data)
        resolve()
      })
    })
  },
  SET_TIMEZONE({ commit, state }, timezone) {
    commit('setTimezone', timezone)
  },
  IMPERSONATE_USER_BY_ID({ commit, state }, userID) {
    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.employers.impersonate.replace('$1', userID)}`,
      {},
      false,
    ).then(response => {
      if (response.data.result !== 'success') {
        commit('updateIsError', true)
        return
      }
      localStorageHelpers.__setToken(response.data.data.token)
      router.push({ path: Vue.config.modules.crm.route.index })
      location.reload()
    })
  },
}
